<template>
  <div class="live-item-animation">
    <div
      v-for="(item, index) in livePlayingData"
      :key="index"
      class="animation-bar"
      ref="lineBar"
    ></div>
  </div>
</template>
<script>
import { siteMixin } from "../../utils/mixin";
export default {
  mixins: [siteMixin],
  data() {
    return {
      livePlayingData: [
        { height: 12, end: false },
        { height: 3, end: false },
        { height: 18, end: false },
        { height: 9, end: false },
      ],
    };
  },
  mounted() {
    this.runPlay();
  },
  beforeDestroy() {
    if (this.task) {
      clearInterval(this.task);
    }
  },
  methods: {
    runPlay() {
      this.task = setInterval(this.playing, 20);
    },
    playing() {
      this.$refs.lineBar.forEach((item, index) => {
        const line = this.$refs.lineBar[index];
        let lineObject = this.livePlayingData[index];
        if (!lineObject.end && lineObject.height < 20) {
          lineObject.height++;
        }
        if (lineObject.end && lineObject.height > 3) {
          lineObject.height--;
        }
        if (lineObject.height === 20) {
          lineObject.end = true;
        }
        if (lineObject.height === 3) {
          lineObject.end = false;
        }
        line.style.height = `${lineObject.height}px`;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.live-item-animation {
  width: 24px;
  height: 28px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  .animation-bar {
    width: 3px;
    height: 3px;
    background: #0e90d2;
    line-height: 0;
  }
}
</style>